
<template>
  <div style="padding:20px">
    <query-form ref="queryForm" class="form" @query="query" :coSeasonList='coSeasonList' :seasonList='seasonList'></query-form>
    <activity-table class="activityTable" ref="mainTable" :seasonList='seasonList' :coSeasonList='coSeasonList'></activity-table>
  </div>
</template>
<script>
import { getAllSeasons } from "../../api.js";
import queryForm from "./queryForm.vue";
import activityTable from "./previewTable.vue";
export default {
  data() {
    return {
      seasonList: [],
      coSeasonList: []
    }
  },
  components: {
    queryForm,
    activityTable
  },
  methods: {
    query(data = {}) {
      data.isReset = true;
      this.$nextTick(() => {
        this.$refs.mainTable.getTableData(data);
      });
    },
    init() {
      Promise.all([getAllSeasons(this.$route.query.id)]).then((res) => {
        if (res && res[0]) {
          console.log(res);
          const { seasonCodeList, coSeasonCodeList } = res[0].data;
          this.seasonList = (seasonCodeList || []).map(item => {
            return {
              label: item.seasonCode,
              value: item.seasonCode,
              adultPendingFlag: item.adultPendingFlag,
              kidsPendingFlag: item.kidsPendingFlag,
              adultEffectiveFlag: item.adultEffectiveFlag,
              kidsEffectiveFlag: item.kidsEffectiveFlag,
              coFlag: item.coFlag,
            }
          });
          this.coSeasonList = (coSeasonCodeList || []).map(item => {
            return {
              label: item.seasonCode,
              value: item.seasonCode,
              adultPendingFlag: item.adultPendingFlag,
              kidsPendingFlag: item.kidsPendingFlag,
              adultEffectiveFlag: item.adultEffectiveFlag,
              kidsEffectiveFlag: item.kidsEffectiveFlag,
              coFlag: item.coFlag,
            }
          });
        }
      }).catch((err) => {
        this.$message.error(err || '请求错误');
      })
    },
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map(item => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$refs.queryForm.emitQuery();
  }
}
</script>
<style lang="less" scoped>

</style>